module.exports = __webpack_public_path__ + "img/18.590aaef3.png";